module.exports = __webpack_public_path__ + "static/img/logo.cdac6d65.svg";